export default __webpack_public_path__ + "08984279f28fd3cd445baaf68fbdabbc.webp";